<template>
  <loader
    v-if="!enrolledApiCall"
    inner-class="{color: red,'text-align': center,padding: 25px,position: relative,top: 175px,left: 10px}"
  />
  <div v-else-if="enrolledApiCall">
    <div class="container-main">
      <div class="puroshkar">
        <h2 class="pre-1">
          <img :src="$root.subscribedGameHeaderImage.thumbnail_path" />
        </h2>
        <Title
          textShadow="font-shadow"
          :title="$root.subscribedGameHeaderImage.title"
          v-if="subscribeTournaments.length"
        />
        <separaror innerClass="seperator" v-if="subscribeTournaments.length" />
        <TournamentList
          :tournaments="subscribeTournaments"
          @enroll="enroll($event)"
          @play="gamePlay($event)"
          inner="inner"
          runningTournament="running-trournament"
          state="Enroll"
          :lastRegistrationTime="ttTime"
          v-if="subscribeTournaments.length"
        />
      </div>
    </div>
    <!--    <div class="sp-line1" v-if="subscribeTournaments.length"></div>-->
    <div class="container-main enr-1">
      <div class="puroshkar">
        <h2 class="pre-1">
          <img :src="$root.tounamentHeaderImage.thumbnail_path" />
        </h2>
        <Title
          :title="$root.tounamentHeaderImage.title"
          textShadow="font-shadow"
        />
        <separaror innerClass="seperator" />
        <TournamentList
          :tournaments="tournaments"
          @enroll="enroll($event)"
          state="Home"
          :lastRegistrationTime="ttTime"
        />
      </div>
    </div>
    <GameRegistration
      @registration="registration($event)"
      @buttonStatus="changeDisableStatus($event)"
      :errorMessage="message"
      :disabled="disabled"
      :button="button"
    />
    <Otp
      @resendCode="resendCode()"
      @otpVerification="otpVerification($event)"
      @buttonStatus="changeDisableStatus($event)"
      :otpAttemptRemaining="otpAttemptRemaining"
      :errorMessage="message"
      :disabled="disabled"
      :button="button"
      :isUserSubscribed="isUserSubscribed"
      :username="name"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Separaror from "@/components/Separaror";
import TournamentList from "@/components/TournamentList";
import Title from "@/components/Title";
import GameRegistration from "@/components/GameRegistration";
import Loader from "@/components/Loader";
import Otp from "@/components/Otp";
import popup from "@/js/popup";
import helper from "@/api/helper";

export default {
  name: "Enrolled",
  components: {
    Separaror,
    TournamentList,
    Title,
    GameRegistration,
    Otp,
    loader: Loader
  },
  data: () => {
    return {
      ttTime: 600,
      button: true,
      disabled: true,
      error: false,
      message: "",
      tournaments: [],
      subscribeTournaments: [],
      otpAttemptRemaining: 10,
      packageId: 0,
      tournamentId: 0,
      msisdn: "",
      enrolledApiCall: false,
      name: "",
      isUserSubscribed: false
    };
  },
  async created() {
    try {
      window.scrollTo(0, 0);
      let userLocalStorageData = this.$root.get_localstorage_user_data(
        "userInfo"
      );
      let { msisdn } = userLocalStorageData;
      const host = this.$root.url();
      const path = "api/v1/hullor/game/enrolled";
      const url = `${host}/${path}`;
      let data = {
        app_type: "wap",
        msisdn: msisdn
      };
      let response = await axios.post(url, data, {
        headers: {
          token: "f3827eeb536655b578de9aaeb53acf73"
        }
      });
      this.enrolledApiCall = true;
      this.$root.homeApiCall = true;
      if (response.data.status === "SUCCESS") {
        let { tournaments, subscribeTournaments, translation } = response.data;
        this.tournaments = tournaments;
        this.subscribeTournaments =
          subscribeTournaments !== undefined ? subscribeTournaments : [];
        this.$root.translation = translation;
        let {
          REWARD,
          RULE,
          BANNER,
          CONTAIN_IMAGE,
          GAME_RULE_IMAGE,
          CONTAIN_ENROLL_IMAGE,
          MORE_TOURNAMENT_IMAGE,
          LOGO,
          FOOTER_LOGO
        } = response.data.allImages;
        this.$root.bannerImage(BANNER, "banners");
        this.$root.bannerImage(REWARD, "rewards");
        this.$root.bannerImage(RULE, "rules");
        this.$root.bannerImage(
          CONTAIN_ENROLL_IMAGE,
          "subscribedGameHeaderImage",
          false
        );
        this.$root.bannerImage(
          MORE_TOURNAMENT_IMAGE,
          "tounamentHeaderImage",
          false
        );
        this.$root.bannerImage(LOGO, "logo", false);
        this.$root.bannerImage(FOOTER_LOGO, "footer_logo", false);
        this.$root.bannerImage(CONTAIN_IMAGE, "containImage", false);
        this.$root.bannerImage(GAME_RULE_IMAGE, "gameRuleImage", false);
      }
    } catch (e) {
      this.enrolledApiCall = true;
      this.error = true;
      this.message = "Something wrong, Please try again later";
      console.log(e);
    }
  },
  mounted() {
    this.timer();
  },
  methods: {
    errorMessage(error) {
      this.error = error.error;
      this.message = error.message;
    },
    timer() {
      this.sleep(1000);
    },
    sleep(ms) {
      let vm = this;
      return setInterval(function() {
        vm.timeChange(vm.tournaments, vm.subscribeTournaments, ms);
      }, ms);
    },
    timeChange(tournaments = [], subscribeTournaments = [], ms = 1000) {
      let s = ms / 1000;
      for (let index in tournaments) {
        if (
          tournaments[index].startDateOfTournamentInSec > 0 ||
          tournaments[index].endDateOfTournamentInSec > 0 ||
          tournaments[index].tournamentEndInSecAgo > 0
        ) {
          if (tournaments[index].tournamentStatus === "notStarted") {
            tournaments[index].startDateOfTournamentInSec =
              tournaments[index].startDateOfTournamentInSec - s;
          } else if (tournaments[index].tournamentStatus === "running") {
            tournaments[index].endDateOfTournamentInSec =
              tournaments[index].endDateOfTournamentInSec - s;
          } else if (tournaments[index].tournamentStatus === "finished") {
            tournaments[index].tournamentEndInSecAgo =
              tournaments[index].tournamentEndInSecAgo + s;
          }
        }
      }
      for (let index in subscribeTournaments) {
        if (
          subscribeTournaments[index].startDateOfTournamentInSec > 0 ||
          subscribeTournaments[index].endDateOfTournamentInSec > 0 ||
          subscribeTournaments[index].tournamentEndInSecAgo > 0
        ) {
          if (subscribeTournaments[index].tournamentStatus === "notStarted") {
            subscribeTournaments[index].startDateOfTournamentInSec =
              subscribeTournaments[index].startDateOfTournamentInSec - s;
          } else if (
            subscribeTournaments[index].tournamentStatus === "running"
          ) {
            subscribeTournaments[index].endDateOfTournamentInSec =
              subscribeTournaments[index].endDateOfTournamentInSec - s;
          } else if (
            subscribeTournaments[index].tournamentStatus === "finished"
          ) {
            subscribeTournaments[index].tournamentEndInSecAgo =
              subscribeTournaments[index].tournamentEndInSecAgo + s;
          }
        }
      }
    },
    async enroll(data = {}) {
      let msg = "",
        notification = "";
      let { packageId, tournamentId, id, index } = data;
      this.packageId = packageId;
      this.tournamentId = tournamentId;
      let userLocalStorageData = this.$root.get_localstorage_user_data(
        "userInfo"
      );
      let { msisdn } = userLocalStorageData;
      if (msisdn === undefined) {
        popup.showModal(id);
        return true;
      } else {
        try {
          const host = this.$root.url();
          const path = "api/v1/hullor/subscriber/directPackagePurchase";
          const url = `${host}/${path}`;
          let data = {
            app_type: "wap",
            msisdn: msisdn,
            packageId: packageId,
            tournamentId: tournamentId
          };
          let response = await axios.post(url, data, {
            headers: {
              token: "f3827eeb536655b578de9aaeb53acf73"
            }
          });
          let { status, message } = response.data;
          if (status === "SUCCESS") {
            if (response.data.tournamentType === "FREE") {
              notification = "success";
              let subscribed_game_data = this.tournaments.splice(index, 1);
              subscribed_game_data[0].isEnrolled = "yes";
              msg = `Successfully subscribed ${subscribed_game_data[0].title} tournament`;
              this.subscribeTournaments.unshift(subscribed_game_data[0]);
              window.scrollTo(0, 0);
            } else {
              window.location.href = response.data.payment_redirect_link;
            }
            return true;
          } else {
            msg = message;
            notification = "warning";
          }
        } catch (e) {
          console.log("catch block ", e);
          msg = e.message;
          notification = "warning";
          return true;
        } finally {
          if (!helper.empty_checker(notification)) {
            helper.pop_up(msg, notification, 4000);
          }
        }
      }
    },
    async gamePlay(data = {}) {
      let { tournamentId } = data;
      let userLocalStorageData = this.$root.get_localstorage_user_data(
        "userInfo"
      );
      let { msisdn } = userLocalStorageData;
      if (msisdn === undefined) {
        return this.$router.push("/");
      } else {
        try {
          const host = this.$root.url();
          const path = "api/v1/hullor/game/play";
          const url = `${host}/${path}`;
          let data = {
            app_type: "wap",
            msisdn: msisdn,
            tournamentId: tournamentId
          };
          let response = await axios.post(url, data, {
            headers: {
              token: "f3827eeb536655b578de9aaeb53acf73"
            }
          });
          if (response.data.status === "SUCCESS") {
            window.open(response.data.gameRedirectUrl);
            return true;
          }
        } catch (e) {
          console.log("catch block ", e);
          return true;
        }
      }
    },
    changeDisableStatus(data = {}) {
      let { isDisable } = data;
      this.disabled = isDisable;
      console.log("BUTTON FINAL DISABLED STATUS :", this.disabled);
    },
    async registration(userInfo = {}) {
      try {
        this.button = false;
        console.log("userInfo ", userInfo);
        let { msisdn } = userInfo;
        const host = this.$root.url();
        const path = "api/v1/hullor/subscriber/registration";
        const url = `${host}/${path}`;
        let data = {
          app_type: "wap",
          msisdn: msisdn
        };
        let response = await axios.post(url, data, {
          headers: {
            token: "f3827eeb536655b578de9aaeb53acf73"
          }
        });
        console.log("response ", response);
        if (response.data.status === "SUCCESS") {
          this.isUserSubscribed = response.data.isUserSubscribed;
          this.name = response.data.username;
          popup.hideModal("regModal");
          popup.showModal("otpModal");
          this.otpAttemptRemaining = response.data.otpAttemptRemaining;
          let errorObject = { error: false, message: null };
          this.errorMessage(errorObject);
          this.msisdn = response.data.msisdn;
        } else {
          let errorObject = { error: true, message: response.data.message };
          this.errorMessage(errorObject);
        }
        this.button = true;
        return true;
      } catch (e) {
        this.button = true;
        console.log("catch block ", e);
        let errorObject = {
          error: true,
          message: "Something wrong,Please try again later"
        };
        this.errorMessage(errorObject);
        return true;
      } finally {
        this.disabled = true;
      }
    },
    async resendCode() {
      try {
        this.button = false;
        const host = this.$root.url();
        const path = "api/v1/hullor/subscriber/resetOtp";
        const url = `${host}/${path}`;
        let data = {
          app_type: "wap",
          msisdn: this.msisdn
        };
        let response = await axios.post(url, data, {
          headers: {
            token: "f3827eeb536655b578de9aaeb53acf73"
          }
        });
        console.log("response ", response);
        if (response.data.status === "SUCCESS") {
          this.otpAttemptRemaining = response.data.otpAttemptRemaining;
          let errorObject = { error: false, message: response.data.message };
          this.errorMessage(errorObject);
        } else {
          let errorObject = { error: true, message: response.data.message };
          this.errorMessage(errorObject);
        }
        this.button = true;
        return true;
      } catch (e) {
        this.button = true;
        console.log("catch block ", e);
        let errorObject = {
          error: true,
          message: "Something wrong,Please try again later"
        };
        this.errorMessage(errorObject);
        return true;
      }
    },
    async otpVerification(otpInfo = {}) {
      try {
        this.button = false;
        console.log("userInfo ", otpInfo);
        let { otp, name } = otpInfo;
        const host = this.$root.url();
        const path = "api/v1/hullor/subscriber/otpVerification";
        const url = `${host}/${path}`;
        name = this.name ? this.name : name;
        let data = {
          app_type: "wap",
          msisdn: this.msisdn,
          name: name,
          otp: otp,
          packageId: this.packageId,
          tournamentId: this.tournamentId
        };
        let response = await axios.post(url, data, {
          headers: {
            token: "f3827eeb536655b578de9aaeb53acf73"
          }
        });
        console.log("response ", response);
        if (response.data.status === "SUCCESS") {
          let userInfo = { msisdn: this.msisdn };
          this.$root.set_localstorage_user_data(userInfo);
          popup.hideModal("otpModal");
          if (response.data.tournamentType !== "FREE") {
            window.location.href = response.data.payment_redirect_link;
          } else {
            window.location.href = "/enrolled";
          }
          // this.$router.push({ name: "Enrolled" });
        } else {
          //popup.hideModal("otpModal");
          if (response.data.code === 3000) {
            // code = 3000 means user already purchase package
            let userInfo = { msisdn: this.msisdn };
            this.$root.set_localstorage_user_data(userInfo);
            window.location.href = "/enrolled";
          }
          let errorObject = { error: true, message: response.data.message };
          this.errorMessage(errorObject);
        }
        this.button = true;
        return true;
      } catch (e) {
        this.button = true;
        console.log("catch block ", e);
        let errorObject = {
          error: true,
          message: "Something wrong,Please try again later"
        };
        this.errorMessage(errorObject);
        return true;
      }
    }
  }
};
</script>
